import { Info } from "lucide-react";
import { Tooltip } from "~/components/Tooltip";
import { Label } from "~/components/ui/label";
import { cn } from "~/lib/utils";

// // // //

export function FilterLabel(props: { label: string; tooltip?: string }) {
    const { label, tooltip } = props;

    if (!tooltip) {
        return (
            <Label className="text-sm font-normal text-tertiary-foreground">
                {label}
            </Label>
        );
    }

    return (
        <Tooltip
            placement="top-start"
            tooltipContent={
                <div className="w-max px-2 py-1">
                    <p className="whitespace-nowrap text-sm">{tooltip}</p>
                </div>
            }
        >
            {({ setTriggerRef }) => (
                <Label
                    ref={setTriggerRef}
                    className={cn(
                        "text-sm font-normal text-tertiary-foreground",
                        {
                            "flex items-center gap-1": tooltip,
                        },
                    )}
                >
                    {label}
                    <Info className="w-4 h-4" />
                </Label>
            )}
        </Tooltip>
    );
}
